import React, { PureComponent } from 'react';
import { Container, Row } from 'reactstrap';
import PageHeader from '../../../shared/components/PageHeader';
import AccountView from './components/AccountView';

class AccountViewPage extends PureComponent {
  render() {
    return (
      <Container>
        <Row>
          <PageHeader
            title="Account Manager View"
            subhead="All Accounts"
          />
        </Row>
        <Row>
          <AccountView />
        </Row>
      </Container>
    );
  }
}

export default AccountViewPage;

